var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import Spinner from "../../Spinner";
import { ButtonRoles } from "../types";
import styled from "styled-components";
import { marginCss } from "../../../../styles/margin";
var spinnerSizes = {
    small: 10,
    medium: 10,
    large: 20,
};
var LoadingSpinner = function (_a) {
    var role = _a.role, size = _a.size;
    return (React.createElement(StyledSpinner, { theme: [ButtonRoles.utilityPrimary, ButtonRoles.utilityTertiary].includes(role) ? "grey" : "pink", width: spinnerSizes[size], height: spinnerSizes[size], marginInlineEnd: "0.5rem" }));
};
var StyledSpinner = styled(Spinner)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), marginCss);
export default LoadingSpinner;
var templateObject_1;
